import { Helmet } from 'react-helmet-async';

const BASE_URL  = 'https://kerekparszakuzletbaja.hu';
const BASE_IMG  = 'https://kerekparszakuzletbaja.hu/logo.png';
const SITE_NAME = 'The Cruiser Shop';

export default function SEO({ title, description, image, url, type = 'website' }) {
  const fullTitle = title ? `${title} | ${SITE_NAME} – Kerékpár Szaküzlet Baja` : `${SITE_NAME} – Kerékpár Szaküzlet Baja | Bács-Kiskun megye`;
  const desc      = description
    ? description.substring(0, 160)
    : 'Kerékpár szaküzlet Baján, Bács-Kiskun megyében. Elektromos, túra, MTB, városi és gyermek kerékpárok. Személyes tanácsadás, szerviz, garancia.';
  const img  = image  || BASE_IMG;
  const href = url    ? `${BASE_URL}${url}` : BASE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />

      {/* Open Graph */}
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image"       content={img} />
      <meta property="og:url"         content={href} />
      <meta property="og:type"        content={type} />
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:locale"      content="hu_HU" />

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image"       content={img} />

      {/* Canonical */}
      <link rel="canonical" href={href} />
    </Helmet>
  );
}
